import axios from 'axios';
import { useSnackbar } from 'notistack';

const useImageKey = () => {
  const { enqueueSnackbar } = useSnackbar();

  const imageRequest = (image, insertRequest, setInsertLoading) => {
    axios
      .post(`https://dl9.projectsd.ir/Uploader/Process`, image, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      })
      .then(res => {
        if (res.status === 200) {
          insertRequest(res.data);
        } else {
          enqueueSnackbar(res?.message, { variant: 'error' });
          setInsertLoading(false);
        }
      })
      .catch(err => {
        console.log(err);
        enqueueSnackbar(err?.message, { variant: 'error' });
        setInsertLoading(false);
      });
  };
  return [imageRequest];
};

export default useImageKey;
